/* eslint-disable prettier/prettier */
export function buildHost() {
    // console.log("buildHost");
    let host = new URL(window.location.href).hostname;;
    if (window.msizerConfiguration.seamlessToken) {
        host += "/myschneider";
    }
    // if (window.msizerConfiguration.isWorkspaceAvailable) {
    //     host += '/workspace';
    // } else if (window.msizerConfiguration.launchFromWorkspace) {
    //     host += '/from-hmc';
    // }
    return host;
}

export const aggregateProductsQuantities = (products) => {
    // console.log("aggregateProductsQuantities");
    const tmpProducts = [];
    products.forEach((product) => {
        if (product.quantity <= 0) return;
        const existIndex = tmpProducts.findIndex((pdct) => pdct.commercialReference === product.commercialReference);
        if (existIndex > -1) {
            tmpProducts[existIndex].quantity += product.quantity;
        } else {
            tmpProducts.push({ ...product });
        }
    });
    return tmpProducts;
};

export const isWorkspaceAvailable = () => {
    return window.msizerConfiguration?.isWorkspaceAvailable || window.msizerConfiguration?.launchFromWorkspace;
};